import deepmerge from "@node/deepmerge";

let locales = {};

const modules = import.meta.glob("@o-din-maintenance/../../config/locales/**/*.yml", { eager: true })

for (const path in modules) {
  locales = deepmerge(locales, modules[path].default);
}

import store from "@o-din-maintenance/src/maintenance/store";
import menu from "@o-din-maintenance/src/maintenance/menu.json";

export default {
  routes: [
    { path: '/maintenance_issues/', component: () => import("./views/maintenance_issues/Index.vue") },
    { path: '/maintenance_issues/archive/', component: () => import("./views/maintenance_issues/Archive.vue") },
    { path: '/maintenance_issues/new/', component: () => import("./views/maintenance_issues/Form.vue") },
    { path: '/maintenance_issues/:id', component: () => import("./views/maintenance_issues/Show.vue") },
    { path: '/maintenance_issues/:id/edit', component: () => import("./views/maintenance_issues/Form.vue") },
    { path: '/maintenance_issues/:id/print', component: () => import("./views/maintenance_issues/Print.vue") },
    { path: '/work_categories', component: () => import("./views/work_categories/Index.vue") },
    { path: '/work_categories/new', component: () => import("./views/work_categories/Form.vue") },
    { path: '/work_categories/:id/edit', component: () => import("./views/work_categories/Form.vue") },
    { path: '/services/', component: () => import("./views/services/Index.vue") },
    { path: '/services/:id/edit', component: () => import("./views/services/Form.vue") },
    { path: '/services/new', component: () => import("./views/services/Form.vue") }

  ],
  locales,
  store,
  menu: [menu]
}
